import { TeamMeetingCapture } from "@/components/TeamMeetingCapture";
import blueprintTexture from "@/assets/blueprint-texture.png";
import { HomeWeatherSummary } from "@/components/HomeWeatherSummary";
import { HomeDashboardStats } from "@/components/HomeDashboardStats";
import { HomeWeekCalendar } from "@/components/HomeWeekCalendar";
import { HomeRecentActivity } from "@/components/HomeRecentActivity";
import { HomeHeader } from "@/components/home/HomeHeader";
import { HomeMobileQuickNav } from "@/components/home/HomeMobileQuickNav";
const Home = () => {
  return (
    <div 
      className="min-h-screen bg-background relative overflow-hidden"
      style={{
        backgroundImage: `url(${blueprintTexture})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'overlay',
      }}
    >
      {/* Blueprint texture overlay */}
      <div 
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: `url(${blueprintTexture})`,
          backgroundSize: '400px 400px',
          backgroundRepeat: 'repeat',
        }}
      />

      {/* Content */}
      <div className="relative z-10 p-6 md:p-12 max-w-7xl mx-auto">
        <HomeHeader />

        {/* Weather Summary - below header */}
        <HomeWeatherSummary />

        {/* Dashboard Widgets - stats/calendar/activity desktop only */}
        <div className="hidden md:block">
          <HomeDashboardStats />
          <HomeWeekCalendar />
          <HomeRecentActivity />
        </div>

        {/* Tagline */}
        <div className="text-center mb-8">
          <p className="text-xl md:text-2xl font-heading text-foreground tracking-wide">
            Plan • Build • Deliver Excellence
          </p>
        </div>

        {/* Quick Nav Cards - mobile only (desktop uses sidebar) */}
        <HomeMobileQuickNav />

      </div>

      <TeamMeetingCapture variant="floating" />
    </div>
  );
};

export default Home;
